import DetailPageV3 from './DetailPageV3'

export default DetailPageV3
// eslint-disable-next-line import/export
export * from './DetailPageV3'
